import { SVGProps, Ref, forwardRef } from 'react';

export const EmployersRatingOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22 5a4 4 0 1 1-8 0 4 4 0 0 1 8 0m-1.8 0a2.2 2.2 0 1 1-4.4 0 2.2 2.2 0 0 1 4.4 0"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2 23v-2.5c0-1.414 0-2.121.44-2.56.439-.44 1.146-.44 2.56-.44h1.8c.474 0 .868 0 1.2.017v-.267c0-1.414 0-2.121.44-2.56.439-.44 1.146-.44 2.56-.44h1.8c.474 0 .868 0 1.2.017V14c0-1.414 0-2.121.44-2.56C14.878 11 15.585 11 17 11h2c1.414 0 2.121 0 2.56.44.44.439.44 1.146.44 2.56v9zm14.11-10.194c.245-.006.53-.006.89-.006h2c.36 0 .645 0 .89.006q.17.005.292.012.008.122.012.293c.006.244.006.529.006.889v7.2h-4.4V14c0-.36 0-.645.006-.89a8 8 0 0 1 .012-.292 8 8 0 0 1 .292-.012M14 17.25v3.95H9.8v-3.95c0-.36 0-.645.006-.89q.005-.17.012-.292.121-.008.293-.012c.244-.006.529-.006.889-.006h1.8c.36 0 .645 0 .89.006q.17.005.292.012.008.121.012.292c.006.245.006.53.006.89M8 21.2v-.7c0-.36 0-.645-.006-.89a8 8 0 0 0-.012-.292 8 8 0 0 0-.292-.012c-.245-.006-.53-.006-.89-.006H5c-.36 0-.645 0-.89.006a8 8 0 0 0-.292.012q-.007.121-.012.292c-.006.245-.006.53-.006.89v.7z"
                fill="currentColor"
            />
        </svg>
    )
);
EmployersRatingOutlinedSize24Glyph.displayName = 'EmployersRatingOutlinedSize24Glyph';
